import { RootState } from '@reducers';

export const selectAuthRouteReducer = (state: RootState) => state.authRouteReducer;
